var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWhatsnew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_whatsnew",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1683",
    "data-name": "Rectangle 1683",
    width: 42,
    height: 42,
    fill: "#6639b7",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16168",
    "data-name": "Trac\\xE9 16168",
    d: "M11.7,26V15.6h7.8v7.8A2.6,2.6,0,0,1,16.9,26ZM9.1,7.8V13H1.3A1.3,1.3,0,0,1,0,11.7V9.1A1.3,1.3,0,0,1,1.3,7.8H2a5.2,5.2,0,0,1,8.4-6.039A5.2,5.2,0,0,1,18.8,7.8h.7a1.3,1.3,0,0,1,1.3,1.3v2.6A1.3,1.3,0,0,1,19.5,13H11.7V7.8ZM9.1,26H3.9a2.6,2.6,0,0,1-2.6-2.6V15.6H9.1Zm0-18.2V5.2A2.6,2.6,0,1,0,6.5,7.8Zm2.6,0h2.6a2.6,2.6,0,1,0-2.6-2.6Z",
    transform: "translate(11 8)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhatsnew);
export default __webpack_public_path__ + "static/media/icon_whatsnew.e4995635a32bbe7473eeac0d3127522f.svg";
export { ForwardRef as ReactComponent };